__turbopack_context__.v({
  "actions": "w2G3lG_actions",
  "dismissBtn": "w2G3lG_dismissBtn",
  "label": "w2G3lG_label",
});
